/* Commande rapide Molto (lot 3).
   Saisie multi-références -> vérification locale (index public SKU -> variante) -> UN SEUL POST /cart/add.js -> relecture du panier.
   Aucun prix, aucun stock. Le panier de la boutique tranche (stock, disponibilité, minimums). Aucun renvoi automatique du POST. */
(function () {
  'use strict';
  var root = document.getElementById('qr-root');
  if (!root || root.dataset.qrInit) return;
  root.dataset.qrInit = '1';

  var $ = function (s) { return root.querySelector(s); };
  var MAX_LIGNES = 100, MAX_QTE = 999999, MAX_OCTETS = 64 * 1024;
  var cfg = { indexUrl: root.dataset.indexUrl, cartUrl: root.dataset.cartUrl, cartAddUrl: root.dataset.cartAddUrl, searchUrl: root.dataset.searchUrl, rootUrl: root.dataset.rootUrl };

  var T = {
    listeVide: 'Ajoutez au moins une référence pour continuer.',
    tropLongue: 'Votre liste dépasse la limite de 100 lignes. Divisez-la en plusieurs listes pour continuer.',
    illisible: 'Nous ne parvenons pas à lire cette ligne.', illisibleAide: 'Exemple : M10001 ; 3.',
    entete: 'Supprimez la ligne d’en-tête « Référence ; Quantité », puis vérifiez à nouveau votre liste.',
    plusieursQuantites: 'Indiquez une seule quantité par référence. Exemple : M10001 ; 3.',
    qteZero: 'Indiquez une quantité supérieure ou égale à 1.',
    qteNegative: 'Les quantités négatives ne sont pas acceptées. Indiquez au moins 1.',
    qteDecimale: 'Indiquez un nombre entier d’unités de vente. Exemple : 2.',
    qteTexte: 'Indiquez une quantité en chiffres, sans lettre ni symbole.',
    qteExcessive: 'La quantité saisie dépasse la limite autorisée (999 999 unités de vente).',
    ambigue: 'Nous ne pouvons pas distinguer la référence de la quantité. Séparez-les par un point-virgule.',
    inconnue: 'Référence introuvable. Vérifiez la référence saisie ou recherchez le produit dans notre catalogue.',
    plusieursProduits: 'Plusieurs produits correspondent à cette référence. Saisissez une référence plus précise.',
    pret: 'Prêt à ajouter', qteAbsente: 'Quantité non renseignée : 1 unité de vente retenue',
    ajoutEnCours: 'Ajout en cours…',
    listeModifiee: 'Votre liste a été modifiée. Vérifiez-la à nouveau avant de l’ajouter au panier.',
    toutesPretes: 'Toutes les lignes sont prêtes à être ajoutées au panier.',
    tarifs: 'Vos tarifs et remises sont affichés dans le panier.',
    listePrete: 'Votre liste est prête !',
    /* nouveaux textes (retours réels du panier, absents de la maquette V2) : à valider par Yoan */
    indexIndispo: 'La commande rapide est momentanément indisponible. Recherchez vos produits dans notre catalogue ou contactez notre équipe.',
    refus: 'Aucun produit n’a été ajouté au panier. Corrigez votre liste ou contactez notre équipe, puis vérifiez-la à nouveau.',
    incertain: 'Nous n’avons pas pu confirmer l’ajout au panier. Vérifiez votre panier avant de recommencer.',
    connexion: 'Connexion interrompue : vérifiez votre panier avant de recommencer.',
    ecart: 'Certaines quantités ajoutées ne correspondent pas à votre liste. Vérifiez votre panier avant de recommencer.',
    nonAjoute: 'Non ajouté. Vérifiez votre panier avant de recommencer.'
  };

  var el = {
    input: $('#qr-input'), count: $('#qr-count'), listError: $('#qr-list-error'), verify: $('#qr-verify'), unavailable: $('#qr-unavailable'),
    results: $('#qr-results'), summary: $('#qr-summary'), errors: $('#qr-errors'), errorsTitle: $('#qr-errors-title'), errorsList: $('#qr-errors-list'),
    rows: $('#qr-rows'), bar: $('.qr-bar'), add: $('#qr-add'), addHelp: $('#qr-add-help'), barNote: $('#qr-bar-note'),
    alert: $('#qr-notice'), alertText: $('#qr-notice-text'), alertDetail: $('#qr-notice-detail'),
    done: $('#qr-done'), doneCount: $('#qr-done-count')
  };

  /* phase : editing | checked | stale | submitting | confirmed | locked (résultat incertain : plus aucun ajout depuis cette liste) */
  var S = { rows: [], phase: 'editing', evaluated: [], lockText: '' };
  var INDEX = null, indexPromise = null, indexError = false;

  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') e.textContent = attrs[k]; else if (attrs[k] !== null && attrs[k] !== undefined && attrs[k] !== false) e.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) e.append(c); });
    return e;
  }
  function icon(id) { var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg'); s.setAttribute('aria-hidden', 'true'); var u = document.createElementNS('http://www.w3.org/2000/svg', 'use'); u.setAttribute('href', '#' + id); s.append(u); return s; }
  function plural(n, one, many) { return n + ' ' + (n > 1 ? many : one); }
  function addedText(q) { return q > 1 ? q + ' unités de vente ajoutées au panier' : q + ' unité de vente ajoutée au panier'; }

  /* ---------- index public SKU -> variante ---------- */
  function normRef(s) { return String(s).replace(/[   ]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = fetch(cfg.indexUrl, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('index ' + r.status); return r.json(); }).then(function (d) {
      if (!d || d.schemaVersion !== 1 || !Array.isArray(d.entries) || d.entries.length !== d.entryCount || d.entryCount < 1) throw new Error('index invalide');
      var exact = new Map(), zeros = new Map();
      d.entries.forEach(function (e) {
        if (typeof e.sku !== 'string' || typeof e.variantId !== 'string' || !e.variantId) throw new Error('entrée invalide');
        var k = normRef(e.sku).toUpperCase();
        (exact.get(k) || exact.set(k, []).get(k)).push(e);
        if (/^\d+$/.test(k)) { var z = k.replace(/^0+/, '') || '0'; (zeros.get(z) || zeros.set(z, []).get(z)).push(e); }
      });
      INDEX = { exact: exact, zeros: zeros, entries: d.entries };
      return INDEX;
    }).catch(function () { indexError = true; el.unavailable.textContent = T.indexIndispo; el.unavailable.hidden = false; el.verify.setAttribute('aria-disabled', 'true'); return null; });
    return indexPromise;
  }

  /* ---------- résolution des références ---------- */
  function resolve(ref) {
    var n = normRef(ref), found;
    if (!n || !INDEX) return { status: 'unknown' };
    found = INDEX.exact.get(n.toUpperCase());
    if (found && found.length === 1) return { status: 'ok', variant: found[0], note: found[0].sku !== n ? 'Référence identifiée : ' + found[0].sku : '' };
    if (found && found.length > 1) return { status: 'ambiguous' };
    var alias = n.replace(/\s+/g, '');
    if (alias !== n) {
      found = INDEX.exact.get(alias.toUpperCase());
      if (found && found.length === 1) return { status: 'ok', variant: found[0], note: 'Référence identifiée : ' + found[0].sku };
      if (found && found.length > 1) return { status: 'ambiguous' };
    }
    if (/^\d+$/.test(alias)) {
      found = INDEX.zeros.get(alias.replace(/^0+/, '') || '0');
      if (found && found.length === 1) return { status: 'ok', variant: found[0], note: 'Référence identifiée : ' + found[0].sku };
      if (found && found.length > 1) return { status: 'ambiguous' };
    }
    return { status: 'unknown' };
  }

  /* ---------- quantités : chiffres ASCII uniquement, jamais d'arrondi ---------- */
  function parseQty(str) {
    var t = String(str).trim();
    if (t === '') return { ok: true, value: 1, absent: true };
    if (/^[0-9]+$/.test(t)) {
      var digits = t.replace(/^0+/, '') || '0';
      if (digits.length > 6 || Number(digits) > MAX_QTE) return { ok: false, msg: T.qteExcessive };
      var v = Number(digits);
      if (v < 1) return { ok: false, msg: T.qteZero };
      return { ok: true, value: v };
    }
    if (/^-\s*\d/.test(t)) return { ok: false, msg: T.qteNegative };
    if (/^\d+[.,]\d*$/.test(t)) return { ok: false, msg: T.qteDecimale };
    return { ok: false, msg: T.qteTexte };
  }

  /* ---------- découpage d'une ligne ---------- */
  function parseLine(raw) {
    var line = String(raw).replace(/^﻿/, '').trim();
    if (/^r[ée]f[ée]rence\s*[;,\t]\s*quantit[ée]$/i.test(line)) return { fmt: { code: 'entete', msg: T.entete } };
    var seps = [';', '\t', ','];
    for (var i = 0; i < seps.length; i++) {
      var sep = seps[i];
      if (line.indexOf(sep) >= 0) {
        var parts = line.split(sep);
        if (sep === ',') { parts = [parts[0], parts.slice(1).join(',')]; }
        if (!parts[0].trim()) return { fmt: { code: 'illisible', msg: T.illisible, help: T.illisibleAide } };
        if (parts.length !== 2) return { fmt: { code: 'multi', msg: T.plusieursQuantites } };
        return { ref: parts[0], qtyStr: parts[1] };
      }
    }
    /* Décision V1 : « 50 34 » demande un point-virgule. Une ligne faite uniquement de groupes de chiffres séparés par des espaces
       peut être une référence (5034) ou une référence suivie d'une quantité (50 ; 34) : on ne tranche jamais, quel que soit l'index. */
    if (/^\d+(\s+\d+)+$/.test(line)) return { fmt: { code: 'ambigu', msg: T.ambigue } };
    var tokens = line.split(/\s+/);
    if (tokens.length === 1) return { ref: line, qtyStr: '' };
    var last = tokens[tokens.length - 1], prefix = tokens.slice(0, -1).join(' ');
    var a = resolve(line), b = resolve(prefix), qb = parseQty(last);
    var validB = b.status === 'ok' && /^\d+$/.test(last) && qb.ok;
    if (a.status === 'ok' && validB) return { fmt: { code: 'ambigu', msg: T.ambigue } };
    if (a.status === 'ok') return { ref: line, qtyStr: '' };
    if (b.status !== 'unknown') return { ref: prefix, qtyStr: last };
    return { ref: line, qtyStr: '' };
  }

  /* ---------- évaluation d'une ligne (sans stock ni prix : le panier tranche) ---------- */
  function evaluateRow(r) {
    var out = { n: r.n, raw: r.raw, notes: [], qty: null, variant: null, err: null, added: null };
    var p = parseLine(r.raw);
    if (p.fmt) { out.err = p.fmt; return out; }
    var res = resolve(p.ref);
    if (res.status === 'unknown') { out.err = { code: 'inconnu', msg: T.inconnue, actions: ['search', 'contact'], searchRef: normRef(p.ref) }; return out; }
    if (res.status === 'ambiguous') { out.err = { code: 'plusieurs', msg: T.plusieursProduits, actions: ['search'], searchRef: normRef(p.ref) }; return out; }
    out.variant = res.variant;
    if (res.note) out.notes.push(res.note);
    var qStr = r.qtyOverride !== null && r.qtyOverride !== undefined ? r.qtyOverride : p.qtyStr;
    var q = parseQty(qStr);
    out.qtyStr = qStr;
    if (!q.ok) { out.err = { code: 'quantite', msg: q.msg }; return out; }
    out.qty = q.value;
    if (q.absent) out.notes.push(T.qteAbsente);
    return out;
  }

  function lignesTexte(nums) { return nums.length > 1 ? 'aux lignes ' + nums.slice(0, -1).join(', ') + ' et ' + nums[nums.length - 1] : 'à la ligne ' + nums[0]; }
  function evaluateAll() {
    var ev = S.rows.map(evaluateRow), byVariant = {};
    ev.forEach(function (e) { if (e.variant) (byVariant[e.variant.variantId] = byVariant[e.variant.variantId] || []).push(e); });
    Object.keys(byVariant).forEach(function (k) {
      var g = byVariant[k]; if (g.length < 2) return;
      g.forEach(function (e) {
        var other = g.filter(function (x) { return x !== e; }).map(function (x) { return x.n; });
        e.err = { code: 'doublon', msg: 'Cette référence figure déjà ' + lignesTexte(other) + '. Regroupez les quantités sur une seule ligne.' };
      });
    });
    S.evaluated = ev;
    return ev;
  }

  /* ---------- saisie ---------- */
  function readInput() {
    var lines = el.input.value.replace(/\r\n?/g, '\n').split('\n'), rows = [];
    lines.forEach(function (l, i) { if (l.replace(/[ \s]/g, '') !== '') rows.push({ n: i + 1, raw: l.trim(), qtyOverride: null, editing: false }); });
    return rows;
  }
  function updateCount() { var n = readInput().length; el.count.textContent = n === 0 ? '0 ligne' : plural(n, 'ligne', 'lignes'); }
  function listError(msg) {
    el.listError.hidden = !msg; el.listError.querySelector('span').textContent = msg || '';
    if (msg) el.input.setAttribute('aria-invalid', 'true'); else el.input.removeAttribute('aria-invalid');
  }

  /* ---------- rendu ---------- */
  function searchHref(ref) { return cfg.searchUrl + (ref ? '?q=' + encodeURIComponent(ref) : ''); }
  function statusCell(e) {
    var confirmed = S.phase === 'confirmed';
    var box = h('div', { class: 'qr-status ' + (e.err ? 'error' : 'ready'), id: 'qr-s-' + e.n });
    if (e.added !== null && e.added !== undefined && (confirmed || S.phase === 'locked')) {
      if (e.added === e.qty) box.append(icon('qr-check'), h('div', { text: addedText(e.added) }));
      else box.append(icon('qr-alert'), h('div', { text: e.added > 0 ? 'Ajout partiel : ' + e.added + ' sur ' + e.qty + ' unités de vente ajoutées au panier. ' + T.nonAjoute : T.nonAjoute }));
      return box;
    }
    if (e.err) {
      var d = h('div', {}, [document.createTextNode(e.err.msg)]);
      if (e.err.help) d.append(h('small', { class: 'qr-note', text: e.err.help }));
      if (e.err.actions) {
        var acts = h('div', { class: 'qr-status-actions' });
        if (e.err.actions.indexOf('search') >= 0) acts.append(h('a', { href: searchHref(e.err.searchRef), text: 'Rechercher le produit' }));
        if (e.err.actions.indexOf('contact') >= 0) acts.append(h('a', { href: '#qr-aide', text: 'Contacter l’équipe' }));
        d.append(acts);
      }
      box.append(icon('qr-alert'), d); return box;
    }
    var ok = h('div', {}, [document.createTextNode(T.pret)]);
    e.notes.forEach(function (n) { ok.append(h('small', { class: 'qr-note', text: n })); });
    box.append(icon('qr-check'), ok); return box;
  }

  function render() {
    var ev = S.evaluated, done = S.phase === 'confirmed' || S.phase === 'locked';
    el.rows.replaceChildren();
    ev.forEach(function (e, i) {
      var row = S.rows[i], err = !!e.err && !done;
      var tr = h('tr', { role: 'row', id: 'qr-row-' + e.n, tabindex: '-1', class: err ? 'is-error' : '' });
      tr.append(h('td', { role: 'cell', class: 'num', text: String(e.n) }));
      var sa = h('td', { role: 'cell', class: 'saisie' });
      if (row.editing && !done) {
        sa.append(h('label', { class: 'qr-sr-only', for: 'qr-r-' + e.n, text: 'Saisie de la ligne ' + e.n }), h('input', { class: 'qr-input', id: 'qr-r-' + e.n, type: 'text', value: row.raw, 'data-edit': e.n, autocomplete: 'off', spellcheck: 'false' }));
      } else sa.append(document.createTextNode(e.raw));
      tr.append(sa);
      var pr = h('td', { role: 'cell', class: 'produit' + (e.variant ? '' : ' qr-empty') });
      if (e.variant) {
        pr.append(h('strong', { text: e.variant.title || e.variant.sku }), h('small', { text: 'Réf. ' + e.variant.sku }),
          h('a', { href: cfg.rootUrl + 'products/' + encodeURIComponent(e.variant.productHandle) + '?variant=' + encodeURIComponent(e.variant.variantId), target: '_blank', rel: 'noopener', 'aria-label': 'Voir la fiche : ' + (e.variant.title || e.variant.sku) + ' (nouvel onglet)', text: 'Voir la fiche' }));
      } else pr.append(document.createTextNode('—'));
      tr.append(pr);
      var qc = h('td', { role: 'cell', class: 'qr-qty-wrap' + (e.variant ? '' : ' qr-empty') });
      if (e.variant) {
        var qin = h('input', { class: 'qr-input qr-qty', id: 'qr-q-' + e.n, type: 'text', inputmode: 'numeric', autocomplete: 'off', value: e.qtyStr !== undefined ? e.qtyStr : '', 'data-qty': e.n, 'aria-describedby': 'qr-s-' + e.n, placeholder: '1' });
        if (e.err && ['quantite', 'doublon'].indexOf(e.err.code) >= 0 && !done) qin.setAttribute('aria-invalid', 'true');
        if (done) qin.setAttribute('readonly', '');
        qc.append(h('label', { for: 'qr-q-' + e.n, text: 'Quantité (en unités de vente)' }), qin);
        if (!done) qc.append(h('small', { text: 'Unités de vente' }));
      } else qc.append(document.createTextNode('—'));
      tr.append(qc);
      var st = h('td', { role: 'cell' }); st.append(statusCell(e)); tr.append(st);
      var ac = h('td', { role: 'cell' });
      if (!done) {
        var wrap = h('div', { class: 'qr-row-actions' });
        wrap.append(h('button', { type: 'button', 'data-act': row.editing ? 'save' : 'edit', 'data-n': e.n, 'aria-label': (row.editing ? 'Valider la modification de la ligne ' : 'Modifier la ligne ') + e.n, text: row.editing ? 'Valider' : 'Modifier' }),
          h('button', { type: 'button', 'data-act': 'del', 'data-n': e.n, 'aria-label': 'Supprimer la ligne ' + e.n, text: 'Supprimer' }));
        ac.append(wrap);
      }
      tr.append(ac); el.rows.append(tr);
    });
    summarize();
  }

  function counts() { var ko = S.evaluated.filter(function (e) { return e.err; }).length; return { ok: S.evaluated.length - ko, ko: ko }; }
  function setAddLabel(txt) { el.add.replaceChildren(document.createTextNode(txt), icon('qr-arrow')); }

  function summarize(prefix) {
    var c = counts(), confirmed = S.phase === 'confirmed', stale = S.phase === 'stale', locked = S.phase === 'locked', n = S.evaluated.length;
    el.summary.replaceChildren();
    var line = h('p', { class: 'qr-summary-line' });
    if (prefix) line.append(h('span', { class: 'ok', text: prefix }));
    if (n === 0) { line.append(h('span', { class: 'ko' }, [icon('qr-alert'), document.createTextNode(T.listeVide)])); el.summary.append(line); }
    else if (confirmed) { line.append(h('span', { class: 'ok' }, [icon('qr-check'), document.createTextNode(plural(c.ok, 'référence ajoutée', 'références ajoutées') + ' au panier')])); el.summary.append(line); }
    else if (locked) { line.append(h('span', { class: 'ko' }, [icon('qr-alert'), document.createTextNode(S.lockText || T.incertain)])); el.summary.append(line); }
    else if (stale) { line.append(h('span', { class: 'ko' }, [icon('qr-alert'), document.createTextNode(T.listeModifiee)])); el.summary.append(line); }
    else if (c.ko === 0) {
      line.append(h('span', { class: 'ok' }, [icon('qr-check'), document.createTextNode(T.listePrete)]));
      el.summary.append(line, h('p', { class: 'qr-summary-sub', text: n > 1 ? 'Les ' + n + ' références ont été vérifiées. Vous pouvez maintenant les ajouter à votre panier.' : 'La référence a été vérifiée. Vous pouvez maintenant l’ajouter à votre panier.' }));
    } else {
      if (c.ok > 0) line.append(h('span', { class: 'ok' }, [icon('qr-check'), document.createTextNode(plural(c.ok, 'ligne prête', 'lignes prêtes'))]), document.createTextNode('·'));
      line.append(h('span', { class: 'ko' }, [icon('qr-alert'), document.createTextNode(plural(c.ko, 'ligne à corriger', 'lignes à corriger'))]));
      el.summary.append(line);
    }
    el.errorsList.replaceChildren();
    var showErr = c.ko > 0 && S.phase === 'checked';
    S.evaluated.forEach(function (e) { if (e.err && showErr) el.errorsList.append(h('li', {}, [h('a', { href: '#qr-row-' + e.n, 'data-goto': e.n, text: 'Ligne ' + e.n + ' : ' + e.err.msg })])); });
    el.errorsTitle.textContent = c.ko > 1 ? 'Corrigez les ' + c.ko + ' lignes signalées pour continuer.' : 'Corrigez la ligne signalée pour continuer.';
    el.errors.hidden = !showErr;
    var can = n > 0 && c.ko === 0 && S.phase === 'checked';
    var done = confirmed || locked;
    el.add.setAttribute('aria-disabled', can ? 'false' : 'true');
    el.add.hidden = done; el.bar.hidden = done;
    if (!done) setAddLabel(can ? (n > 1 ? 'Ajouter les ' + n + ' références au panier' : 'Ajouter la référence au panier') : 'Ajouter au panier');
    el.addHelp.textContent = can ? '' : (stale ? T.listeModifiee : (n === 0 ? T.listeVide : el.errorsTitle.textContent));
    el.barNote.textContent = (n === 0) ? T.tarifs : (can ? T.toutesPretes + ' ' + T.tarifs : (stale ? T.listeModifiee : el.errorsTitle.textContent + ' ' + T.tarifs));
    if (S.phase !== 'checked' && S.phase !== 'submitting') { /* l'alerte de réponse du panier ne vaut que pour la liste vérifiée */ }
  }

  function showAlert(text, detail, focus) {
    el.alertText.textContent = text; el.alertDetail.textContent = detail || ''; el.alertDetail.hidden = !detail; el.alert.hidden = false;
    if (focus) el.alert.focus();
  }
  function hideAlert() { el.alert.hidden = true; }

  /* ---------- panier : un seul POST, relecture avant/après, rapprochement ---------- */
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function readCart() {
    var tries = [0, 700, 1600], i = 0;
    function essai() {
      return fetch(cfg.cartUrl + '.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
        .catch(function (e) { i++; if (i >= tries.length) throw e; return sleep(tries[i]).then(essai); });
    }
    return essai();
  }
  function qtyByVariant(cart) { var m = {}; (cart.items || []).forEach(function (it) { m[String(it.variant_id)] = (m[String(it.variant_id)] || 0) + it.quantity; }); return m; }
  function notifyCart(cart) {
    try {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'molto-commande-rapide', data: { source: 'molto-commande-rapide', itemCount: cart.item_count } };
      document.dispatchEvent(ev);
    } catch (e) { /* non bloquant */ }
  }

  function confirmAdd() {
    if (el.add.getAttribute('aria-disabled') === 'true' || S.phase !== 'checked') return;
    var lines = S.evaluated.map(function (e) { return { e: e, id: e.variant.variantId, qty: e.qty }; });
    var items = lines.map(function (l) { return { id: Number(l.id), quantity: l.qty }; });
    if (items.some(function (it) { return !Number.isSafeInteger(it.id); })) { showAlert(T.incertain, '', true); return; }
    S.phase = 'submitting'; hideAlert();
    el.add.setAttribute('aria-disabled', 'true'); setAddLabel(T.ajoutEnCours);
    var before = null, status = null, detail = '', networkFailure = false;
    readCart().then(function (c) { before = c; }, function () { before = null; })
      .then(function () {
        if (!before) throw { stop: 'avant' };                       // relecture impossible : on n'envoie rien
        var ctl = typeof AbortController === 'function' ? new AbortController() : null, timer = ctl ? setTimeout(function () { ctl.abort(); }, 25000) : null;
        return fetch(cfg.cartAddUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }), signal: ctl ? ctl.signal : undefined })
          .then(function (r) { status = r.status; return r.text(); })
          .then(function (t) { try { var j = JSON.parse(t); detail = (j && (j.description || j.message)) ? String(j.description || j.message) : ''; } catch (e) { detail = ''; } })
          .catch(function () { networkFailure = true; })
          .then(function () { if (timer) clearTimeout(timer); });
      })
      .then(function () { return readCart().catch(function () { return null; }); })
      .then(function (after) {
        if (!after) { lockUncertain(networkFailure ? T.connexion : T.incertain); return; }
        var b = qtyByVariant(before), a = qtyByVariant(after), allOk = true, any = false;
        lines.forEach(function (l) { l.e.added = Math.max(0, (a[l.id] || 0) - (b[l.id] || 0)); if (l.e.added !== l.qty) allOk = false; if (l.e.added > 0) any = true; });
        notifyCart(after);
        if (status === 200 && allOk) { finishConfirmed(); return; }
        if (!any && !networkFailure && status && status >= 400 && status < 500 && status !== 429) {      // refus net : rien n'a changé dans le panier
          lines.forEach(function (l) { l.e.added = null; });
          S.phase = 'checked'; render(); showAlert(T.refus, detail, true); return;
        }
        lockUncertain(any ? T.ecart : (networkFailure ? T.connexion : T.incertain), detail);
      })
      .catch(function (e) {
        if (e && e.stop === 'avant') { S.phase = 'checked'; render(); showAlert(T.connexion.replace('vérifiez votre panier avant de recommencer.', 'rien n’a été envoyé, vous pouvez réessayer.'), '', true); return; }
        lockUncertain(T.incertain);
      });
  }
  function lockUncertain(text, detail) {
    S.phase = 'locked'; S.lockText = text; render(); showAlert(text, detail, true);
  }
  function finishConfirmed() {
    S.phase = 'confirmed'; render();
    var n = S.evaluated.length;
    el.doneCount.textContent = plural(n, 'référence ajoutée', 'références ajoutées') + ' avec succès.'; el.done.hidden = false; el.done.focus();
  }

  /* ---------- actions ---------- */
  function verify() {
    var rows = readInput();
    el.done.hidden = true; hideAlert();
    if (rows.length === 0) { S.rows = []; S.evaluated = []; S.phase = 'editing'; el.results.hidden = true; listError(T.listeVide); el.input.focus(); return; }
    if (rows.length > MAX_LIGNES || new Blob([el.input.value]).size > MAX_OCTETS) { el.results.hidden = true; listError(T.tropLongue); el.input.focus(); return; }
    listError('');
    loadIndex().then(function (idx) {
      if (!idx) return;
      S.rows = rows; S.phase = 'checked'; evaluateAll(); el.results.hidden = false; render();
      if (counts().ko) el.errors.focus(); else el.results.focus();
    });
  }
  function reset() {
    el.input.value = ''; updateCount(); listError(''); S = { rows: [], phase: 'editing', evaluated: [], lockText: '' };
    el.results.hidden = true; el.done.hidden = true; hideAlert();
  }
  function revalidateRow() { if (S.phase === 'submitting' || S.phase === 'confirmed' || S.phase === 'locked') return; S.phase = 'checked'; evaluateAll(); }
  function commitEdit(n, focusAfter) {
    var row = S.rows.filter(function (r) { return r.n === n; })[0]; if (!row) return;
    var inp = $('#qr-r-' + n); if (inp) { row.raw = inp.value.trim(); row.qtyOverride = null; }
    row.editing = false; revalidateRow(); render();
    if (focusAfter) { var b = $('[data-act="edit"][data-n="' + n + '"]'); if (b) b.focus(); }
  }
  function exempleTexte() {
    if (!INDEX) return '';
    var e = INDEX.entries, pick = [e[0], e[Math.floor(e.length / 3)], e[Math.floor(2 * e.length / 3)]].filter(Boolean);
    return pick.map(function (x, i) { return [x.sku + ' ; 3', x.sku.toLowerCase() + ', 2', x.sku + '\t10'][i]; }).join('\n');
  }

  /* ---------- événements ---------- */
  el.input.addEventListener('input', function () {
    updateCount(); if (el.input.getAttribute('aria-invalid')) listError('');
    if (S.phase === 'checked') { S.phase = 'stale'; hideAlert(); summarize(); }
    else if (S.phase === 'confirmed' || S.phase === 'locked') { S.phase = 'stale'; el.done.hidden = true; hideAlert(); render(); }
  });
  el.verify.addEventListener('click', function () { if (el.verify.getAttribute('aria-disabled') === 'true') return; verify(); });
  $('#qr-example').addEventListener('click', function () {
    loadIndex().then(function () { if (!INDEX) return; el.input.value = exempleTexte(); updateCount(); listError(''); if (S.phase === 'checked') { S.phase = 'stale'; summarize(); } el.input.focus(); });
  });
  $('#qr-clear').addEventListener('click', function () { reset(); el.input.focus(); });
  el.add.addEventListener('click', confirmAdd);
  $('#qr-new').addEventListener('click', function () { reset(); el.input.focus(); window.scrollTo({ top: 0 }); });

  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('button,a'); if (!t) return;
    if (t.hasAttribute('data-goto')) {
      ev.preventDefault(); var n = t.getAttribute('data-goto'), row = $('#qr-row-' + n);
      var tgt = row && (row.querySelector('[aria-invalid="true"]') || row.querySelector('input') || row.querySelector('[data-act="edit"]'));
      if (tgt) tgt.focus(); else if (row) row.focus(); return;
    }
    var act = t.getAttribute('data-act'); if (!act) return;
    var nn = Number(t.getAttribute('data-n')), row2 = S.rows.filter(function (r) { return r.n === nn; })[0]; if (!row2) return;
    if (act === 'edit') { row2.editing = true; render(); var i = $('#qr-r-' + nn); if (i) { i.focus(); i.select(); } }
    else if (act === 'save') commitEdit(nn, true);
    else if (act === 'del') {
      S.rows = S.rows.filter(function (r) { return r.n !== nn; }); revalidateRow(); render();
      summarize('Ligne ' + nn + ' supprimée. ');
      var nextFocus = $('.qr-row-actions button') || el.results; nextFocus.focus();
    }
  });
  root.addEventListener('change', function (ev) {
    var q = ev.target.closest('[data-qty]'); if (!q) return;
    var n = Number(q.getAttribute('data-qty')), row = S.rows.filter(function (r) { return r.n === n; })[0]; if (!row) return;
    row.qtyOverride = q.value; revalidateRow(); render();
    var again = $('#qr-q-' + n); if (again && document.activeElement === document.body) again.focus();
  });
  /* Entrée dans un champ de ligne : validation locale seulement, jamais d'envoi ni de paiement. */
  root.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || ev.isComposing) return;
    var t = ev.target;
    if (t.matches && t.matches('[data-qty]')) { ev.preventDefault(); ev.stopPropagation(); t.dispatchEvent(new Event('change', { bubbles: true })); }
    else if (t.matches && t.matches('[data-edit]')) { ev.preventDefault(); ev.stopPropagation(); commitEdit(Number(t.getAttribute('data-edit')), true); }
  });

  updateCount();
  loadIndex();
})();
